import { BillingsOrderForwardBillingsListItem } from "../../../../../../common/services/billings/order-forward-billings/list/billings-order-forward-billings-list";
import BillingsTaxiTransferredOrderListingItem from "../types/billings-taxi-transferred-order-listing-item";
import BillingsTaxiTransferredOrderListingItemBillingStatus from "../types/billings-taxi-transferred-order-listing-item-billing-status";

const createListingItemStatus = (
  responseDataItem: BillingsOrderForwardBillingsListItem,
): BillingsTaxiTransferredOrderListingItemBillingStatus | undefined => {
  switch (responseDataItem.status) {
    case "CREATED":
      return BillingsTaxiTransferredOrderListingItemBillingStatus.CREATED;
    case "ACCEPTED":
      return BillingsTaxiTransferredOrderListingItemBillingStatus.ACCEPTED;
    case "REJECTED":
      return BillingsTaxiTransferredOrderListingItemBillingStatus.REJECTED;
    case "REOPENED":
      return BillingsTaxiTransferredOrderListingItemBillingStatus.REOPENED;
    case "REOPEN_REQUEST":
      return BillingsTaxiTransferredOrderListingItemBillingStatus.REOPEN_REQUEST;
    default:
      return undefined;
  }
};

const createListingItem = (
  responseDataItem: BillingsOrderForwardBillingsListItem,
): BillingsTaxiTransferredOrderListingItem => {
  return {
    status: createListingItemStatus(responseDataItem),
    uuid: responseDataItem.id,
    internalOrderId: responseDataItem.cargoOrder.humanId,
    orderStartDate: new Date(responseDataItem.startTime),
    orderTransferDate: new Date(responseDataItem.forwardingTime),
    producerTaxi: responseDataItem.producer.name,
    consumerTaxi: responseDataItem.consumer.name,
    billingModel: responseDataItem.billingModel,
    distance: responseDataItem.distance,
    amountForDistance: responseDataItem.amountForDistance,
    baseDistanceRate: responseDataItem.baseDistanceRate,
    stopoverCost: responseDataItem.amountForChargeHaltings,
    tollRoadsCost: responseDataItem.amountForChargeHighways,
    totalCost: responseDataItem.allContributionsAmount,
    sumOfBonuses: responseDataItem.sumOfBonuses ?? 0,
    sumOfPenalties: responseDataItem.sumOfPenalties ?? 0,
    contractName: responseDataItem.contractName,
    route: responseDataItem.route,
  };
};

const createListingItems = (
  responseDataItems: BillingsOrderForwardBillingsListItem[],
): BillingsTaxiTransferredOrderListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const billingsTaxiTransferredOrderListingFactory = {
  createListingItems,
};

export default billingsTaxiTransferredOrderListingFactory;
